import React, { useContext, useEffect, useState } from 'react';
import '../../../assests/css/admin/DepartmentManagement.css';
import Adminmasterlayout from '../../../layouts/Adminmasterlayout/Adminmasterlayout';
import axios from 'axios';
import { AppContext } from '../../../context/Appcontext';
import Swal from 'sweetalert2';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Spinner } from 'react-bootstrap';

const DepartmentManagement = () => {
  const { baseUrl } = useContext(AppContext);

  const [departments, setDepartments] = useState([]);
  const [deptIdForUpdate, setDeptIdForUpdate] = useState(null);
  const [deptName, setDeptName] = useState('');
  const [HOD, setHOD] = useState('');
  const [status, setStatus] = useState('Active');
  const [showModal, setShowModal] = useState(false);

  // ── Loading states (added for spinners, no existing logic changed) ──
  const [isSubmitting, setIsSubmitting] = useState(false); // Add/Update button spinner
  const resetForm = () => {
    setDeptName('');
    setHOD('');
    setStatus('Active');
    setDeptIdForUpdate(null);
  };

  const viewAllDepartments = () => {
    axios
      .get(`${baseUrl}/admin/department/viewAllDepartments`)
      .then((response) => {
        console.log(response.data);
        setDepartments(response.data.departments);
      })
      .catch((error) => {
        console.log(error);
      });
  };

const addDepartment = () => {
  if (!deptName || !HOD) return;

  const formdata = new FormData();
  formdata.append('deptName', deptName);
  formdata.append('HOD', HOD);
  formdata.append('status', status);

  setIsSubmitting(true);

  axios
    .post(`${baseUrl}/admin/department/addDepartment`, formdata, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((response) => {
      console.log(response);

      if (response.data.success == true) {
        viewAllDepartments();
        resetForm();
        setShowModal(false);

        Swal.fire({
          icon: "success",
          title: "Wow",
          confirmButtonText: "Okay",
        });
      }

      // Spinner band
      setIsSubmitting(false);
    })
    .catch((error) => {
      console.log(error);

      // Error ki surat mein bhi spinner band
      setIsSubmitting(false);
    });
};




const updateDepartment = () => {
  console.log("Updated ka function chl rha ha");

  if (!deptName || !HOD) return;

  const formdata = new FormData();

  formdata.append('ngdepartment_id', deptIdForUpdate);
  formdata.append('deptName', deptName);
  formdata.append('HOD', HOD);
  formdata.append('status', status);

  setIsSubmitting(true);

  axios
    .post(`${baseUrl}/admin/department/updateDepartment`, formdata, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((response) => {
      console.log(response.data);

      // Departments dobara fetch
      viewAllDepartments();

      // Form reset
      resetForm();

      // Modal close
      setShowModal(false);

      // Spinner band
      setIsSubmitting(false);
    })
    .catch((error) => {
      console.error(error);

      // Error aaye tab bhi spinner band
      setIsSubmitting(false);
    });
};


  //   const formdata = new FormData();
  //   formdata.append('ngdepartment_id', dept.id);
  //   // formdata.append('deptStatus', dept.status === 'Active' ? 'Inactive' : 'Active');

  //   setTogglingId(dept.id);
  //   axios
  //     .post(`${baseUrl}/admin/department/updateDepartment`, formdata, {
  //       headers: { 'Content-Type': 'multipart/form-data' },
  //     })
  //     .then((response) => {
  //       console.log(response);
  //       viewAllDepartments();
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //     })
   
  // };

  useEffect(() => {
    viewAllDepartments();
    console.log("************************")
    console.log("************************")
    console.log("************************")
    console.log("************************")
  }, []);

  const handleOpenAddModal = () => {
    resetForm();
    setShowModal(true);
  };

  const handleOpenEditModal = (dept) => {
    setDeptIdForUpdate(dept.id);

    setDeptName(dept.deptName);

    setHOD(dept.HOD);
    setStatus(dept.status);
    setShowModal(true);
  };
  
  const handleCloseModal = () => {
    resetForm();
    setShowModal(false);
  };

  const handleSubmit = () => {
    if (deptIdForUpdate === null) {
      addDepartment();
    } else {
      updateDepartment();
    }
  };


  return (
    <Adminmasterlayout>
      <div className="dept-container">
        <div className="dept-main">

          {/* ── Header ── */}
          <div className="dept-header">
            <div className="dept-header__content">
              <h1 className="dept-header__title">Department Management</h1>
              <p className="dept-header__subtitle">
                Manage and organize your Collage  departments
              </p>
            </div>
            <button
              className="dept-btn dept-btn--primary"
              onClick={handleOpenAddModal}
            >
              + Add Department
            </button>
          </div>

          {/* ── Table ── */}
          <div className="dept-table-container">
            <table className="dept-table">
              <thead className="dept-table__head">
                <tr>
                  <th className="dept-table__th">ID</th>
                  <th className="dept-table__th">Department Name</th>
                  <th className="dept-table__th">HOD</th>
                  <th className="dept-table__th">Status</th>
                  <th className="dept-table__th">Actions</th>
                </tr>
              </thead>
              <tbody className="dept-table__body">
                {departments.length > 0 ? (
                  departments.map((dept) => (
                    <tr key={dept.id} className="dept-table__row">
                      <td className="dept-table__td">{dept.id}</td>
                      <td className="dept-table__td dept-table__td--bold">
                        {dept.deptName}
                      </td>
                      <td className="dept-table__td">{dept.HOD}</td>
                      <td className="dept-table__td">
                        <span
                          className={`dept-badge dept-badge--${(dept.status || '').toLowerCase()}`}
                        >
                          {dept.status}
                        </span>
                      </td>
                      <td className="dept-table__td">
                        <div className="dept-action-buttons">
                          <button
                            className="dept-toggle-btn dept-toggle-btn--edit"
                            title="Edit Department"
                            onClick={() => handleOpenEditModal(dept)}
                           
                          >
                            Edit
                          </button>

                          
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr className="dept-table__row">
                    <td
                      className="dept-table__td dept-table__td--empty"
                      colSpan="5"
                    >
                      <div className="dept-empty-state">
                        <div className="dept-empty-state__icon">🏢</div>
                        <p className="dept-empty-state__text">
                          No departments found
                        </p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

        </div>
      </div>

      {/* ── Modal ── */}
      {showModal && (
        <div className="dept-modal">
          <div
            className="dept-modal__overlay"
            onClick={handleCloseModal}
          />
          <div className="dept-modal__content">
            <div className="dept-modal__header">
              <h2 className="dept-modal__title">
                {deptIdForUpdate === null ? 'Add New Department' : 'Edit Department'}
              </h2>
              <button
                className="dept-modal__close"
                onClick={handleCloseModal}
              >
                ×
              </button>
            </div>

            <div className="dept-form">
              <div className="dept-form__group">
                <label className="dept-form__label">Department Name</label>
                <input
                  type="text"
                  value={deptName}
                  onChange={(e) => setDeptName(e.target.value)}
                  className="dept-form__input"
                  placeholder="Enter department name"
                  required
                />
              </div>

              <div className="dept-form__group">
                <label className="dept-form__label">HOD</label>
                <input
                  type="text"
                  value={HOD}
                  onChange={(e) => setHOD(e.target.value)}
                  className="dept-form__input"
                  placeholder="Enter HOD name"
                  required
                />
              </div>

              <div className="dept-form__group">
                <label className="dept-form__label">Status</label>
                <select
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                  className="dept-form__select"
                >
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </select>
              </div>

              <div className="dept-form__actions">
                <button
                  className="dept-btn dept-btn--secondary"
                  onClick={handleCloseModal}
                  disabled={isSubmitting}
                >
                  Cancel
                </button>
                {isSubmitting ? (
                  <Spinner size="lg" />
                ) : (
                  <button
                    className="dept-btn dept-btn--primary"
                    onClick={handleSubmit}
                  >
                    {deptIdForUpdate === null ? 'Add Department' : 'Update Department'}
                  </button>
                  
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </Adminmasterlayout>
  );
};

export default DepartmentManagement;